export default "__VITE_ASSET__C8V$8myR__"